import { createAsyncThunk, createSlice, Dictionary } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';

const ASW_ENDPOINT = 'api/public/asw_message';

export enum AswParamsEnum {
  COMPLETE = 'complete',
  PRICE = 'price',
  FIRST_PRICE = 'first_price',
  DATE = 'date',
  // Custom state uses when we don't need to send anything
  NOT_SEND = 'not_send'
}

export interface AswResponse {
  message: string;
  is_asw_sent: boolean;
}

export interface AswParams {
  job: string;
  status?: string;
  params?: AswParamsEnum;
}

export const getAsw = createAsyncThunk<{ result: AswResponse; identifier: string }, AswParams>(
  'asw/get',
  async ({ job, status, params }, api) => {
    const response = await makeRequest(ASW_ENDPOINT, {
      additionalGetParams: {
        job,
        status,
        params
      }
    })(api);

    return {
      result: response?.data,
      identifier: `${job}/${status}/${params ? params : ''}`
    };
  }
);

export const sendAswMessage = createAsyncThunk<{ result: AswResponse; identifier: string }, AswParams>(
  'asw/post',
  async ({ job, params }, api) => {
    const response = await makeRequest(ASW_ENDPOINT, {
      method: 'POST',
      additionalGetParams: {
        job,
        params
      }
    })(api);

    return response;
  }
);

export const aswSlice = createSlice({
  name: 'asw',
  initialState: {
    messages: {},
    storedParams: {}
  } as {
    messages: Dictionary<AswResponse>;
    storedParams: Dictionary<AswParamsEnum>
  },
  reducers: {
    storeAswParams: (state, action) => {
      state.storedParams = {
        ...state.storedParams,
        [action.payload.identifier]: action.payload.params
      };
    }
  },
  extraReducers: builder => {
    builder.addCase(getAsw.fulfilled, (state, action) => {
      state.messages = {
        ...state.messages,
        [action.payload.identifier]: action.payload.result
      };
    });
  }
});

export const { storeAswParams } = aswSlice.actions;

export const selectAswParams = identifier => state => state.asw.storedParams[identifier];
